/**
 * JWT que el cliente SignalR manda al conectar (el backend lo lee de
 * `?access_token=` en las rutas /hub y decide a qué grupos se une la conexión).
 *
 * Fuente de verdad: la cabecera Authorization de axios (la fija `setSession`
 * al hacer login / iniciar sesión QR). Si aún no está (reload antes de que el
 * provider rehidrate), se lee de localStorage "accessToken".
 *
 * `accessTokenFactory` se invoca en cada (re)conexión, así que un token
 * renovado se usa automáticamente en el siguiente reconnect.
 */
export function extractBearerToken(authorizationHeader, storage) {
  if (typeof authorizationHeader === "string") {
    const match = authorizationHeader.match(/^Bearer\s+(.+)$/i);
    if (match && match[1] && match[1] !== "null" && match[1] !== "undefined") {
      return match[1].trim();
    }
  }
  try {
    const stored = storage?.getItem("accessToken");
    return stored && stored !== "null" && stored !== "undefined" ? stored : "";
  } catch {
    return "";
  }
}

export default function getHubAccessToken() {
  // Import perezoso: evita un ciclo de módulos axios ↔ hubs en el arranque.
  // eslint-disable-next-line global-require
  const axios = require("../axios").default;
  const header = axios?.defaults?.headers?.common?.Authorization;
  const storage = typeof window !== "undefined" ? window.localStorage : undefined;
  return extractBearerToken(header, storage);
}
